export default "__VITE_ASSET__1437f260__"